//#region IMPORTS
import { InstoreBasketItem } from "../../models/instoreBasket";
import { formatPrice } from "../../helpers/formatPrice";
import formatArticleName from "../../helpers/formatArticleName";
import { useTranslation } from "react-i18next";
//#endregion

//#region INTERFACE
interface Props {
  item: InstoreBasketItem;
}
//#endregion

export default function InstoreBasketConfirmItem({ item }: Props) {
  const { t } = useTranslation();

  //#region RENDER
  return (
    <div
      key={item.template_row_id}
      className="grid grid-cols-[40px_1fr_auto_auto] gap-x-6 items-center px-4 py-2 text-left text-sm border-t border-b border-black even:bg-[#f2f2f2] lg:h-20 lg:text-base"
    >
      <p className="font-semibold text-lg lg:text-2xl text-right">
        {item.quantity}
      </p>
      <div className="flex flex-col">
        <p className="font-medium">
          {formatArticleName(item.article_name) || "—"}
        </p>
        <p className="text-sm text-[#254559]">
          {item.theme}
          {item.store_format ? ` · ${item.store_format}` : ""}
        </p>
      </div>

      {/* Set depth, left of the price column. */}
      <div className="text-xs text-gray-500 text-right whitespace-nowrap">
        {typeof item.set === "number"
          ? `${t("rituals.setDepth")}: ${item.set}`
          : ""}
      </div>

      {/* Price: line total (unit × qty) above the unit price, both understated —
          same as the basket item, the order total is what should stand out.
          typeof-guard so empty values simply render nothing. */}
      <div className="flex flex-col items-end justify-center leading-tight text-right whitespace-nowrap">
        {typeof item.price === "number" && (
          <>
            <span className="text-xs font-semibold text-gray-500">
              {formatPrice(item.price * item.quantity)}
            </span>
            <span className="text-xs text-gray-500">
              {formatPrice(item.price)} × {item.quantity}
            </span>
          </>
        )}
      </div>
    </div>
  );
  //#endregion
}
